export const EVENTS = {
	USER_ENTERED_ONBOARDING: 'User entered onboarding',
	USER_ENTERED_SCANNER: 'User entered scanner',
	ERROR_OCCURRED: 'Error occurred',
	DOMAIN_HAS_BEEN_READ: 'Domain has been read',
	getAll: () => Object.values(EVENTS).filter(v => typeof v === 'string'),
	isValid: value => EVENTS.getAll().includes(value),
};
